<app-nav titulo="Detalles del propietario" descripcion="Aqui podrá ver toda la información que tenemos acerca del propietario seleccionado.">
    <div class="owner-details">
        <app-owner-details-content [owner]="owner" *ngIf="owner"></app-owner-details-content>
    </div>
</app-nav>
